import {Component, HostBinding} from '@angular/core';

// Services
import {AppService} from '../../services/app-service';
import {NavigationService} from '../../services/navigation-service';
import {AppCatalogService} from '../../../catalog/shared/services/app-catalog-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:QuickMenuCmp'));

@Component({
    selector: 'quick-menu-cmp',
    template: require('./quick-menu.cmp.html'),
    styles: [String(require('./quick-menu.cmp.scss'))],
    host: { id: 'quick-menu', class: 'quick-menu' }
})
export class QuickMenuCmp {

    @HostBinding('class.hidden') quickMenuIsHidden: boolean = false;

    
    constructor (
        private _appService: AppService,
        private _navigationService: NavigationService,
        private _appCatalogService: AppCatalogService
    ) {
        // 'Construct quick menu component' );
    }

    prevTopCategory() {
        // this._uiLayoutService.prevTopCategory();
    }

    nextTopCategory() {
        // this._uiLayoutService.nextTopCategory();
    }

    openNavigationCart() {
        // this._uiLayoutService.events.openNavigationCart.emit(null);
    }

    openOptionsMenu() {
        // this._uiLayoutService.events.openOptionsMenu.emit(null);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/components/layout/quick-menu.cmp.ts